import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, FetchOrderWithLines, PopulateApiParameter, SendDataToApi } from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/Reorder";
import { CartLineCollectionModel, CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import { dispatchAddToCartEvent } from "@store/Services/AnalyticsService"; // Poolcorp Custom Code
import { getOrder } from "@store/Services/OrderService"; // Poolcorp Custom Code


replaceInChain(chain, FetchOrderWithLines, async props => {
    const order = await getOrder({ orderNumber: props.parameter.orderNumber, expand: ["orderLines"] }); // Poolcorp Custom Import
    props.apiResult = { order };
});

replaceInChain(chain, PopulateApiParameter, props => {
    if (!props.apiResult?.order.orderLines?.some(o => !!o.productId)) {
        props.apiResult = undefined;
        props.dispatch({
            type: "Pages/OrderHistory/CompleteReorder",
            orderNumber: props.parameter.orderNumber,
        });
        props.dispatch({
            type: "Context/CompleteUpdatingCart",
        });
        props.parameter.onError?.(siteMessage("OrderHistory_NoProductsAvailableForReorder") as string);
        return false;
    }

    props.apiParameter = {
        cartLines: props.apiResult.order.orderLines.map(
            (line: OrderLineModel) =>
                ({
                    shortDescription: line.shortDescription, // Poolcorp Custom Code
                    productId: line.productId,
                    qtyOrdered: line.qtyOrdered ? line.qtyOrdered : line.qtyShipped + line.properties?.backorderQty, // Poolcorp Custom Code
                    unitOfMeasure: line.unitOfMeasure,
                } as CartLineModel),
        ),
    } as CartLineCollectionModel;
});

addToChainAfter(chain, SendDataToApi, props => {
    const state = props.getState();
    const currentCurency = state.context.session.currency?.currencyCode;
    if (props.apiParameter.cartLines) {
        dispatchAddToCartEvent(props.apiParameter.cartLines, currentCurency);
    }
});
